<template>
	<div class="cast-detail">
		<div class="cast-detail__setter">
			<form
				id="cast-detail-form"
				ref="leftSetterElem"
				:class="[
					'cast-detail__left-setter',
					{
						'cast-detail__left-setter--float': floatLeftSetter,
					},
				]"
				@submit.prevent="submit"
			>
				<ManagingSection size="l" class="cast-detail__left-setter-item">
					<ManagingBox v-if="isModifyPage" title="항번">
						{{ detail.idPouch }}
					</ManagingBox>
					<ManagingBox v-if="isModifyPage" title="생성일">
						{{ detail.createDate }}
					</ManagingBox>
					<ManagingBox title="노출여부">
						<RadioList
							v-model="isDisplay"
							:radioList="isDisplayList"
						/>
						<DateBox v-model="startDate" :disabled="!isDisplay" />
					</ManagingBox>
					<ManagingBox title="베스트캐스트 설정">
						<RadioList v-model="isBest" :radioList="isBestList" />
						<DateRange v-model="bestPeriod" :disabled="!isBest" />
					</ManagingBox>
					<ManagingBox
						:title="`썸네일 이미지<br>(${imageSizeLimit.width} * ${imageSizeLimit.height})`"
					>
						<ImageUploader
							ref="imageUploader"
							group="pouch"
							:imageSizeLimit="imageSizeLimit"
							@upload="onUploadImage"
						/>
					</ManagingBox>
					<ManagingBox title="제목">
						<TextCounter
							v-model="pouchTitle"
							:useTextarea="true"
							:useLineLimit="true"
							:rows="2"
							:maxLength="50"
						/>
					</ManagingBox>
					<ManagingBox title="Description">
						<TextCounter
							v-model="description"
							:useTextarea="true"
							:maxLength="200"
						/>
					</ManagingBox>
					<ManagingBox title="카테고리">
						<Selector
							v-model="idPouchCategory"
							:optionList="categoryList"
							nameKey="label"
						/>
					</ManagingBox>
					<ManagingBox title="어워드 연동">
						<Selector
							v-model="idHitProducts"
							:optionList="awardsList"
						/>
					</ManagingBox>
				</ManagingSection>
				<ManagingSection v-if="isModifyPage" :splice="true" size="l">
					<ManagingBox title="기타정보">
						<CastEtcList
							:etcList="etcList"
							:castId="detail.idPouch"
							:castTitle="detail.pouchTitle"
						/>
					</ManagingBox>
				</ManagingSection>
			</form>
			<div class="cast-detail__right-setter">
				<ManagingSection
					v-if="isLegacy"
					header="구 본문"
					class="cast-detail__conts"
				>
					<ManagingBox title="본문 내용">
						<TextEditor
							v-model="pouchText"
							:width="520"
							:height="520"
						/>
					</ManagingBox>
					<ManagingBox title="태그">
						<CastTags
							v-model="pouchTags"
							:pouchTagsText="pouchTagsText"
							@inputText="pouchTagsTextChange"
						/>
					</ManagingBox>
					<ManagingBox title="제품정보">
						<ProductSearcher2
							:absoluteList="false"
							class="cast-detail__pdt-searcher"
							@change="addProduct"
						/>
						<EditorPickFormProducts
							:list="products"
							class="cast-detail__pdt-list"
							@remove="removeProduct"
							@sortEnd="productsSortEnd"
						/>
					</ManagingBox>
				</ManagingSection>
				<template v-else>
					<ManagingSection header="본문" class="cast-detail__conts">
						<ManagingBox title="메인 이미지">
							<ImgListSelector
								v-model="mainImage"
								:useLink="false"
								:maxLength="1"
							/>
						</ManagingBox>
					</ManagingSection>
					<CastModuleList
						ref="castModuleList"
						:moduleList="detail && detail.moduleList"
					/>
					<ManagingSection>
						<ManagingBox title="태그">
							<CastTags
								v-model="pouchTags"
								:pouchTagsText="pouchTagsText"
								@inputText="pouchTagsTextChange"
							/>
						</ManagingBox>
					</ManagingSection>
				</template>
			</div>
		</div>
		<div class="btn-wrap-main cast-detail__button-wrapper">
			<button
				form="cast-detail-form"
				type="submit"
				class="btn-main blue"
				v-text="isModifyPage ? '수정' : '등록'"
			/>
			<button
				v-if="!isLegacy"
				type="button"
				class="btn-main blue"
				v-text="'미리보기'"
				@click="preview"
			/>
			<button
				type="button"
				class="btn-main blue bordered"
				v-text="'취소'"
				@click="cancel"
			/>
		</div>
	</div>
</template>
<script>
	import uniq from 'lodash/uniq';
	import isEmpty from 'lodash/isEmpty';
	import moment from 'moment';
	import { getImagePath, getS3Url, uploadS3 } from '@/util';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList.vue';
	import DateBox from '@/components/DateBox.vue';
	import DateRange from '@/components/DateRange.vue';
	import ImageUploader from '@/components/ImageUploader.vue';
	import TextCounter from '@/components/TextCounter.vue';
	import Selector from '@/components/Selector.vue';
	import CastEtcList from '@/components/cast/CastEtcList.vue';
	import TextEditor from '@/components/TextEditor.vue';
	import CastTags from '@/components/cast/CastTags.vue';
	import ProductSearcher2 from '@/components/ProductSearcher2.vue';
	import EditorPickFormProducts from '@/components/cast/EditorPickFormProducts.vue';
	import ImgListSelector from '@/components/ImgListSelector.vue';
	import CastModuleList from '@/components/cast/CastModuleList.vue';

	export default {
		name: 'CastDetail',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			DateBox,
			DateRange,
			ImageUploader,
			TextCounter,
			Selector,
			CastEtcList,
			TextEditor,
			CastTags,
			ProductSearcher2,
			EditorPickFormProducts,
			ImgListSelector,
			CastModuleList,
		},
		props: {
			detail: {
				type: Object,
				default: undefined,
			},
		},
		data() {
			return {
				isDisplayList: [
					{ id: true, value: '노출' },
					{ id: false, value: '미노출' },
				],
				isDisplay: undefined,
				startDate: '',
				isBestList: [
					{ id: 1, value: '노출' },
					{ id: 0, value: '미노출' },
				],
				isBest: undefined,
				bestPeriod: { from: '', to: '' },
				imageSizeLimit: {
					width: 1029,
					height: 564,
					type: 'fit',
				},
				imageDto: {},
				pouchTitle: '',
				description: '',
				categoryList: [],
				idPouchCategory: undefined,
				etcList: [],
				pouchText: '',
				pouchTags: [],
				pouchTagsText: '',
				products: [],
				mainImage: [],
				floatLeftSetter: false,
				idHitProducts: null,
				pdtDetailLink: 'glowpick://glowpick.com?type=product_id&value=',
			};
		},
		computed: {
			isModifyPage() {
				return !!this.detail;
			},
			isLegacy() {
				return this.isModifyPage && !this.detail.moduleList;
			},
			payloadKeys() {
				return [
					'fileDir',
					'fileSaveName',
					'fileSize',
					'fileType',
					'fileOrgName',
					'path',
					'idRegister',
					'idPouch',
					'pouchTitle',
					'description',
					'idPouchCategory',
					'isDisplay',
					'startDate',
					'bestEndOn',
					'bestStartOn',
					'isBest',
					'pouchTags',
					'idHitProductsList',
					...(this.isLegacy
						? ['pouchText', 'products']
						: ['mainImage', 'moduleList']),
					'bodyText',
				];
			},
			awardsList() {
				return [
					{ value: null, name: '미선택' },
					...this.$store.state.filter.awardsList.map(item => ({
						value: item.idHitProducts,
						name: item.hitText,
					})),
				];
			},
		},
		methods: {
			async setCategoryList() {
				try {
					const { data } = await this.$axiosNoah.get(
						'/pouch/category',
						{ params: { limit: 999 } }
					);
					this.categoryList = [
						{
							value: null,
							label: '-- 카테고리 선택 --',
						},
						...data.pouchCategoryList
							.filter(item => item.isDisplay)
							.map(item => ({
								value: item.idPouchCategory,
								label: item.pouchCategoryText,
							})),
					];
				} catch (err) {
					console.error(err);
					alert(
						'캐스트카테고리 조회 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			setDetail(detail = {}) {
				this.isDisplay = detail.hasOwnProperty('isDisplay')
					? detail.isDisplay
					: this.isDisplayList[0].id;
				this.startDate = detail.hasOwnProperty('startDate')
					? detail.startDate
					: '';
				this.isBest = detail.hasOwnProperty('isBest')
					? detail.isBest
					: this.isBestList[1].id;
				this.bestPeriod = {
					from: detail.hasOwnProperty('bestStartOn')
						? detail.bestPeriod.from
						: '',
					to: detail.hasOwnProperty('bestEndOn')
						? detail.bestPeriod.to
						: '',
				};
				if (detail.hasOwnProperty('imageDto')) {
					const { fileDir, fileSaveName } = (this.imageDto =
						detail.imageDto);
					this.$refs.imageUploader.setImageByUrl(
						getImagePath(fileDir, fileSaveName)
					);
				} else {
					this.imageDto = {};
				}
				this.pouchTitle = detail.hasOwnProperty('pouchTitle')
					? detail.pouchTitle
					: '';
				this.description = detail.hasOwnProperty('description')
					? detail.description
					: '';
				this.idPouchCategory = detail.hasOwnProperty('idPouchCategory')
					? detail.idPouchCategory
					: null;
				this.etcList = detail.etcList;
				this.pouchText = detail.hasOwnProperty('pouchText')
					? detail.pouchText
					: '';
				if (detail.hasOwnProperty('pouchTags')) {
					this.pouchTags = detail.pouchTags;
					this.pouchTagsText = detail.pouchTags.join(',');
				} else {
					this.pouchTags = [];
					this.pouchTagsText = '';
				}
				if (detail.hasOwnProperty('products')) {
					this.products = detail.products.map(item => ({
						idProduct: item.idProduct,
						title: `[${item.idProduct}/${item.brandTitle}] ${item.productTitle}`,
						image: getImagePath(item.fileDir, item.fileSaveName),
					}));
				} else {
					this.products = [];
				}
				if (!this.isLegacy) {
					this.mainImage = detail?.mainImage || [];
				}
				if (detail.awardHitProducts) {
					this.idHitProducts = detail.awardHitProducts.idHitProducts;
				}
			},
			onUploadImage(imageDto) {
				this.imageDto = imageDto;
			},
			pouchTagsTextChange(pouchTagsText) {
				this.pouchTagsText = pouchTagsText;
			},
			addProduct(product) {
				if (!product) return;
				if (
					this.products.some(
						item => item.idProduct === product.idProduct
					)
				) {
					alert('이미 추가된 제품 입니다');
					return;
				}
				this.products = [
					...this.products,
					{
						...product,
						image: product.filePath,
						title: `[${product.idProduct}/${product.brandTitle}] ${product.productTitle}`,
					},
				];
			},
			removeProduct(idProduct) {
				const newProducts = [...this.products];
				newProducts.splice(
					this.products.findIndex(
						item => item.idProduct === idProduct
					),
					1
				);
				this.products = newProducts;
			},
			productsSortEnd(products) {
				this.products = products;
			},
			getFormatDate(condition, datStr, format) {
				return condition && datStr
					? moment(datStr, 'YYYY-MM-DDTHH:mm').format(format)
					: null;
			},
			getUniqPdtIdList(moduleList) {
				return uniq(
					moduleList.reduce((acc, cur) => {
						if (cur.id === 'pdt') {
							acc = [...acc, ...cur.pdtList];
						} else if (cur.id === 'img') {
							const pdtList =
								cur.imgList
									.filter(
										item =>
											item.link.indexOf(
												this.pdtDetailLink
											) > -1
									)
									.map(item =>
										Number(
											item.link.split(
												this.pdtDetailLink
											)[1]
										)
									) || [];
							acc = [...acc, ...pdtList];
						}
						return acc;
					}, [])
				);
			},
			async getPayload(isPreview) {
				const moduleList = this.isLegacy
					? null
					: await this.$refs.castModuleList.getList();
				let mainImage = this.mainImage?.[0];

				if (
					!isPreview &&
					this.isBest &&
					(!this.bestPeriod.to || !this.bestPeriod.from)
				) {
					alert('베스트캐스트 노출 기간을 입력하세요.');
					throw '정합성';
				}
				if (!isPreview && isEmpty(this.imageDto)) {
					alert('썸네일 이미지를 등록하세요.');
					throw '정합성';
				}
				if (!this.pouchTitle) {
					alert('제목을 입력하세요.');
					throw '정합성';
				}
				if (!this.idPouchCategory) {
					alert('카테고리를 선택하세요.');
					throw '정합성';
				}
				if (this.isLegacy) {
					// 기존 캐스트
					if (!this.pouchText) {
						alert('본문 내용을 입력하세요.');
						throw '정합성';
					}
				} else {
					// 신 모듈화 캐스트
					if (!mainImage) {
						// 메인 이미지가 없을 때
						alert('메인 이미지를 등록하세요.');
						throw '정합성';
					}
					if (typeof mainImage === 'object') {
						// 메인 이미지가 업로드 전 일 때
						const { data } = await getS3Url(
							mainImage.extension,
							'cast-module'
						);
						await uploadS3(data, mainImage.fileObject);
						mainImage = `${this.$store.state.env.IMAGE_STORAGE_PATH}/${data.fields.key}`;
					}
					if (!moduleList.length) {
						alert('1개 이상의 모듈을 추가해주세요.');
						throw '정합성';
					}
					moduleList.forEach(module => {
						if (module.id === 'img' && !module.imgList.length) {
							alert('이미지 모듈에 이미지를 등록하세요');
							throw '정합성';
						}
						if (module.id === 'txt' && !module.conts) {
							alert('텍스트 모듈에 내용을 입력하세요');
							throw '정합성';
						}
						if (module.id === 'youtube' && !module.conts) {
							alert('동영상 모듈에 내용을 입력하세요');
							throw '정합성';
						}
						if (module.id === 'pdt' && !module.pdtList.length) {
							alert('제품 모듈에 제품을 등록하세요');
							throw '정합성';
						}
					});
				}
				return this.payloadKeys.reduce((acc, key) => {
					if (key.indexOf('file') === 0) {
						acc[key] = this.imageDto[key];
					} else if (key === 'path') {
						acc[key] =
							`${this.imageDto.fileDir}/${this.imageDto.fileSaveName}`;
					} else if (key === 'idRegister') {
						acc[key] = this.$store.state.login.idRegister;
					} else if (key === 'idPouch') {
						acc[key] = this.isModifyPage
							? this.detail.idPouch
							: null;
					} else if (key === 'products') {
						acc[key] = this.products.map(item => item.idProduct);
					} else if (key === 'startDate') {
						acc[key] = this.getFormatDate(
							this.isDisplay,
							this[key],
							'YYYYMMDDHHmmss'
						);
					} else if (key === 'bestEndOn') {
						acc[key] = this.getFormatDate(
							this.isBest,
							this.bestPeriod.to,
							'x'
						);
					} else if (key === 'bestStartOn') {
						acc[key] = this.getFormatDate(
							this.isBest,
							this.bestPeriod.from,
							'x'
						);
					} else if (key === 'mainImage') {
						acc[key] = mainImage;
					} else if (key === 'moduleList') {
						acc[key] = JSON.stringify(moduleList);
						acc.moduleProductList =
							this.getUniqPdtIdList(moduleList);
						acc.pouchText = '';
					} else if (key === 'idHitProductsList') {
						acc[key] = this.idHitProducts
							? [this.idHitProducts]
							: null;
					} else if (key === 'bodyText') {
						acc[key] =
							this.$refs.castModuleList?.$refs.moduleElem
								.filter(
									({ data }) =>
										data.id === 'txt' && data.conts
								)
								.map(elem =>
									elem.$refs.tinymce.editor.getContent({
										format: 'text',
									})
								)
								.join('') || null;
					} else {
						acc[key] = this[key];
					}
					return acc;
				}, {});
			},
			goBackToList() {
				const path = '/cast/list';
				if (document.referrer.indexOf(path) > -1) {
					this.$router.go(-1);
				} else {
					this.$router.push(path);
				}
			},
			async submit() {
				this.$store.commit('toggleSpinner', true);
				const submitData = this.isModifyPage
					? {
							typeName: '수정',
							reqMethod: 'put',
							reqPath: `/pouch/${this.detail.idPouch}`,
						}
					: {
							typeName: '등록',
							reqMethod: 'post',
							reqPath: '/pouch',
						};
				try {
					if (!confirm(`${submitData.typeName} 하시겠습니까?`))
						return;
					submitData.payload = await this.getPayload();
					await this.$axiosNoah[submitData.reqMethod](
						submitData.reqPath,
						submitData.payload
					);
					alert(`${submitData.typeName} 되었습니다.`);
					this.goBackToList();
				} catch (err) {
					console.error(err);
					if (err !== '정합성') {
						alert(
							`${submitData.typeName} 실패했습니다. 개발팀에 문의하세요.`
						);
					}
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
			async preview() {
				try {
					const {
						mainImage,
						idPouchCategory,
						pouchTitle,
						description,
						moduleList,
						moduleProductList,
					} = await this.getPayload(true);
					const params = {
						pouchInfo: {
							mainImage,
							pouchCategoryText: this.categoryList.find(
								item => item.value === idPouchCategory
							).label,
							pouchTitle,
							description,
						},
						moduleList,
						moduleProductList,
					};
					const {
						data: { id },
					} = await this.$axiosAdmin2.post(
						'/admin-api/v2/pouch/preview',
						params
					);
					window.open(
						`${this.$store.state.env.glowpickDomain}/dev/preview/cast/${id}`,
						'_blank'
					);
				} catch (err) {
					console.error(err);
					if (err !== '정합성') {
						alert(
							'미리보기 생성 실패했습니다. 개발팀에 문의하세요.'
						);
					}
				}
			},
			cancel() {
				if (!confirm('작성을 취소 하시겠습니까?')) return;
				this.goBackToList();
			},
			domScrollE(elemTop) {
				return () => {
					if (window.scrollY >= elemTop) {
						this.floatLeftSetter = true;
					} else {
						this.floatLeftSetter = false;
					}
				};
			},
			offScrollEvent() {
				document.removeEventListener('scroll', this.domScrollE());
			},
			setScrollEvent(elemTop) {
				document.addEventListener('scroll', this.domScrollE(elemTop));
			},
		},
		async mounted() {
			const elemTop =
				this.$refs.leftSetterElem.getBoundingClientRect().top;
			this.domScrollE(elemTop);
			this.setScrollEvent(elemTop);
			await this.setCategoryList();
			this.setDetail(this.detail);
		},
		beforeMount() {
			this.offScrollEvent();
		},
	};
</script>
<style lang="scss" scoped>
	.cast-detail {
		padding-bottom: 386px;

		&__setter {
			position: relative;
			display: flex;
			width: 100%;
			margin-top: 24px;
			align-items: flex-start;
			justify-content: flex-end;
		}

		&__left-setter {
			width: 50%;
			padding-right: 8px;
		}

		&__left-setter--float {
			overflow-y: auto;
			position: fixed;
			width: calc(((100% - 80px) / 2));
			max-height: 100%;
			left: 40px;
			top: 0;
		}

		&__left-setter-item {
			padding-top: 0;
		}

		&__right-setter {
			width: 50%;
			padding-left: 8px;
			padding-right: 40px;
		}

		&__conts {
			padding-top: 0;
		}

		&__category {
			display: block;
			width: 100%;
		}

		&__pdt-searcher {
			z-index: 100;
		}

		&__pdt-list {
			margin-top: 26px;
			width: 100%;
		}

		&__button-wrapper {
			z-index: 4999;
			position: fixed;
			right: 120px;
			bottom: 40px;
			padding: 0;
		}
	}
</style>
